import React from 'react';
import { HorizontalScroll } from '../HorizontalScroll/HorizontalScroll';
import { AllowableGutter } from '../../fundamentals/spaces/space';

export interface HorizontalScrollContainerProps {
  isApplied?: boolean;
  scrollToItem?: number;
  gapContainer?: AllowableGutter;
  gapInner?: AllowableGutter;
  showAddTabButton?: boolean;
}

export const HorizontalScrollContainer: React.FC<React.PropsWithChildren<HorizontalScrollContainerProps>> = ({
  isApplied,
  scrollToItem,
  gapContainer,
  gapInner,
  showAddTabButton,
  children
}) => {
  return isApplied ? (
    <HorizontalScroll scrollToItem={scrollToItem} gapContainer={gapContainer} gapInner={gapInner} showAddTabButton={showAddTabButton}>
      {children}
    </HorizontalScroll>
  ) : (
    <>{children}</>
  );
};
